/**
 * Global integration functions.
 *
 * @moduile app/integration/globals
 */
import _ from 'lodash';
import Login from '../components/Login';

/**
 * A function that does nothing.
 *
 * @type {Function}
 * @returns {void}
 * @nosideeffects
 * @private
 */
var emptyFunction = function () {
};

/**
 * Create the namespace.
 *
 * @type {Function}
 * @returns {void}
 * @nosideeffects
 * @private
 */
var createNamespace = function () {

    if (window.WH && window.WH.sportsbook) {
        return _.extend(
            window.WH.sportsbook,
            createStubbedFunctions()
        );
    }

    return createStubbedFunctions();
};

/**
 * Stub out the integration functions.
 *
 * @type {Function}
 * @returns {void}
 * @nosideeffects
 * @private
 */
var createStubbedFunctions = function () {

    return {
        changePage: emptyFunction,
        addToSlip: emptyFunction,
        ready: emptyFunction,
        isLoggedIn: Login.isLoggedIn,
    };
};

/**
 * Public functions.
 *
 * @type {Object}
 * @public
 */
var api = {

    /**
     * Initialise the integration functions.
     *
     * @type {Function}
     * @param {Object} window Global object.
     * @returns {void}
     * @sideeffects
     * @public
     */
    initialise: function (window) {

        window.WH = window.WH || {};

        window.WH.sportsbook = createNamespace();
    },
};

export default api;
